export default class SelectionQuizBAnswer {
  constructor(public readonly choiceId: string) {}
}
